export function getCode() {
  const queryString = window.location.search.replace("?", "");
  const queryStringSplits = queryString.split("&");
  // eslint-disable-next-line functional/no-let
  let code;
  queryStringSplits.forEach(function (split) {
    const entry = split.split("=");
    // eslint-disable-next-line functional/no-conditional-statement
    if (entry[0] === "code") {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      code = entry[1];
    }
  });

  return code;
}
